import { render } from "./OidoValueListItem.vue?vue&type=template&id=a3781ff8&scoped=true"
import script from "./OidoValueListItem.vue?vue&type=script&lang=js"
export * from "./OidoValueListItem.vue?vue&type=script&lang=js"

import "./OidoValueListItem.vue?vue&type=style&index=0&id=a3781ff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3781ff8"]])

export default __exports__